module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('input', {
    ref: "autocomplete",
    class: _vm.classname,
    attrs: {
      "name": "streetAddress",
      "type": "text",
      "id": _vm.id,
      "placeholder": _vm.placeholder
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "focus": function($event) {
        _vm.onFocus()
      },
      "blur": function($event) {
        _vm.onBlur()
      },
      "change": _vm.onChange,
      "keypress": _vm.onKeyPress,
      "input": function($event) {
        _vm.updateStreet()
      }
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e635b50c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/components/widgets/google-autocomplete.vue
// module id = 574
// module chunks = 1